import { Action, Reducer } from "redux";
import { OJEUMWD3Thermostat, OJEUMWD3Thermostats } from "./models";
import { KnownAction } from "./actionTypes";
import { base64ToByteArray } from "../../Utility";

const unloadedThermostats: OJEUMWD3Thermostats = {
    thermostats: [],
    loadable: [],
    distributors: [],
    users: []
};

const mapThermostat = (thermostat: OJEUMWD3Thermostat): OJEUMWD3Thermostat => {
    return {
        ...thermostat,
        deviceInfo: {
            ...thermostat.deviceInfo,
            mcuUuid: base64ToByteArray(thermostat.deviceInfo.mcuUuid as unknown as string),
            protocolVersion: base64ToByteArray(thermostat.deviceInfo.protocolVersion as unknown as string)
        }
    };
};

const mapThermostats = (thermostats: OJEUMWD3Thermostat[]): OJEUMWD3Thermostat[] => {
    return thermostats.map(mapThermostat);
};

export const OJEUMWD3Reducer: Reducer<OJEUMWD3Thermostats> = (state: OJEUMWD3Thermostats | undefined, incomingAction: Action): OJEUMWD3Thermostats => {
    if (state === undefined) {
        return unloadedThermostats;
    }

    const action = incomingAction as KnownAction;
    switch (action.type) {
        case "RECEIVE_ALL_OJEUMWD3_THERMOSTATS":
            return { ...state, thermostats: mapThermostats(action.thermostats) };
        case "RECEIVE_NEW_OJEUMWD3_THERMOSTAT":
            return { ...state, thermostats: [...state.thermostats, mapThermostat(action.thermostat)] };
        case "UPDATE_OJEUMWD3_THERMOSTAT_STATE":
            return { ...state, thermostats: state.thermostats.map(thermostat => (thermostat.thermostatId === action.thermostat.thermostatId ? mapThermostat(action.thermostat) : thermostat)) };
        case "REMOVE_OJEUMWD3_THERMOSTAT":
            return { ...state, thermostats: state.thermostats.filter(thermostat => thermostat.thermostatId !== action.id) };
        case "RECEIVE_LOADABLE_OJEUMWD3_THERMOSTATS":
            return { ...state, loadable: action.thermostats };
        case "ADD_LOADABLE_OJEUMWD3_THERMOSTAT":
            return { ...state, loadable: [...state.loadable, action.thermostat] };
        case "REMOVE_LOADABLE_OJEUMWD3_THERMOSTAT":
            return { ...state, loadable: state.loadable.filter(thermostat => thermostat.thermostatId !== action.id) };
        case "UPDATE_LOADABLE_OJEUMWD3_THERMOSTAT":
            return { ...state, loadable: state.loadable.map(thermostat => thermostat.thermostatId === action.thermostat.thermostatId ? action.thermostat : thermostat) };
        case "RECEIVE_DISTRIBUTOR_SEARCH_RESULT":
            return { ...state, distributors: action.distributors };
        case "RECEIVE_USER_SEARCH_RESULT":
            return { ...state, users: action.users };
        default:
            return state;
    }
};